<template>
  <v-dialog v-model="visible" scrollable max-width="400px" v-if="site">
    <v-card>
      <v-card-title>
        <p class="ma-0 pa-0">
          <span class="text-h5">Bestellung</span>
          <br />
          <span class="text-h4 title primary--text">
            {{ site.name }}
          </span>
        </p>
      </v-card-title>
      <v-card-text>
        <template v-for="item in orderDialogChoices">
          <v-checkbox
            v-model="selected"
            :label="
              item.isEnabled
                ? `${item.title}`
                : `${item.title} (${item.whyDisabled})`
            "
            :disabled="!item.isEnabled"
            :value="item"
            :key="item.id"
            class="pa-2 ma-0 order-choice"
          ></v-checkbox>
          <v-divider :key="item.id + 'divider'" />
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="visible = false"> Abbrechen</v-btn>
        <v-btn
          color="primary"
          text
          :disabled="orderDialogChoices.length === 0 || selected.length === 0"
          @click="
            () => {
              visible = false;
              $emit('orderClick', selected);
            }
          "
        >
          Bestellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogOrderInput',
  components: {},
  props: ['site', 'dialogVisible'],
  data: () => ({
    visible: false,
    selected: [],
  }),
  watch: {
    dialogVisible() {
      this.visible = this.dialogVisible;
      if (this.visible) this.selected = [];
    },
  },
  computed: {
    orderDialogChoices() {
      if (!this.site || !this.site.shafts || this.site.shafts.length === 0)
        return [];

      var choices = [];
      this.site.shafts.forEach(shaft => {
        let copiedShaft = Object.assign({}, shaft);
        if (shaft)
          if (
            !shaft.input_channel ||
            !shaft.input_channel.diameter ||
            !shaft.output_channel ||
            !shaft.output_channel.diameter
          ) {
            copiedShaft.isEnabled = false;
            copiedShaft.whyDisabled = 'unvollständig';
          } else if (shaft.ordered) {
            copiedShaft.isEnabled = false;
            copiedShaft.whyDisabled = 'bereits bestellt';
          } else {
            copiedShaft.isEnabled = true;
          }

        choices.push(copiedShaft);
        choices.sort(function(a, b) {
          return b.isEnabled - a.isEnabled;
        });
      });

      return choices;
    },
  },
  methods: {},
};
</script>

<style scoped>
.title {
  font-family: 'Playfair Display' !important;
}

.order-choice >>> .v-messages {
  height: 0;
  min-height: 0;
}
</style>
